const getSearchPageNarrowHeaderStyles = () => ({
    zIndex: 10,
});

export default getSearchPageNarrowHeaderStyles;
